import { SensorConversions } from "../conversionFunctions/sensorConversions.js";
import { SensorElementConfig } from "./types.js";

export const temperatureElementConfig: SensorElementConfig<Record<string, never>, typeof SensorConversions.unity> = {
    legalConvertedRange: [-50, 100],
    conversionKey: "unity",
    parameterConfigs: {},
    buildConversionParams: () => ({}),
    decodedUnits: "celsius",
    convertedUnits: "celsius",
    unitCategory: "airTemperature",
    testCases: [
        { parameters: {}, decodedValue: 25, convertedValue: 25 },
        { parameters: {}, decodedValue: -10, convertedValue: -10 },
    ],
} as const;
